module.exports = __webpack_public_path__ + "static/media/generic-as.31b779ea.jpeg";